import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useIdleListeners } from "../../hooks/useIdleListeners";
import { useIdleTimer } from "react-idle-timer";
import { crossTabIdleListen } from "../../utilities/idleUtilities";

export const Timer =  memo(() => {
    let userInfo = useSelector(state => state.user.userInfo);
    let isAnon = useSelector((state) => state.app.isAnonymous);
    let idleSettings = useSelector((state) => state.app.idleSettings);
    let idleListeners = useIdleListeners();
    let idleTimer = useIdleTimer({
        ...idleListeners,
        timeout: idleSettings.timeout - idleSettings.promptBeforeIdle,
        stopOnIdle: true,
        disabled: isAnon || !userInfo
      });
      const [idleInterval, setIdleInterval] = useState(null);

      useEffect(() => {
        if (idleTimer && userInfo && !isAnon && !idleInterval) {
        setIdleInterval(crossTabIdleListen(idleTimer));
        }
    }, [idleTimer, userInfo, isAnon])


    return <>
    <div></div>
    </>;
});